import NewsArticleHeader from './news-article-header';

export default NewsArticleHeader;
